import gql from "graphql-tag";
import { CART_FRAGMENT } from "@src/pages/Cart/queries";

export const CART_SELECT_ALL = gql`
  ${CART_FRAGMENT}
  mutation cartSelectAll($id: ID!, $selected: Boolean!) {
    cartSelectAll(id: $id, selected: $selected) {
      cart {
        ...cartFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CARTLINES_DELETE = gql`
  ${CART_FRAGMENT}
  mutation cartLinesDelete($cartId: ID!, $lines: [ID]!) {
    cartLinesDelete(cartId: $cartId, lines: $lines) {
      cart {
        ...cartFragment
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CARTLINES_UPDATE = gql`
  ${CART_FRAGMENT}
  mutation cartLinesUpdate($cartId: ID!, $input: [CartLineBulkUpdateInput]!) {
    cartLineBulkUpdate(cartId: $cartId, input: $input) {
      cart {
        ...cartFragment
      }
      errors {
        message
      }
    }
  }
`;

export const CARTLINE_DELETE = gql`
  ${CART_FRAGMENT}
  mutation cartLineDelete($cartId: ID!, $lineId: ID) {
    cartLineDelete(cartId: $cartId, lineId: $lineId) {
      cart {
        ...cartFragment
      }
      errors {
        message
      }
    }
  }
`;

export const CARTLINE_TO_WISHLIST = gql`
  ${CART_FRAGMENT}
  mutation wishlistAddProduct($input: DeleteCartLineInput!, $productId: ID!) {
    wishlistAddProduct(input: $input, product_id: $productId) {
      cart {
        ...cartFragment
      }
      errors {
        message
      }
    }
  }
`;

export const CHECKOUT_CREATE = gql`
  mutation checkoutCreate($input: CheckoutCreateInput!) {
    checkoutCreate(input: $input) {
      errors {
        field
        message
      }
      checkout {
        messages {
          level
          message
        }
      }
    }
  }
`;
